<template>
    <div>
        <h1>Dislike questions and answers</h1>
        <v-layout>
            <h2>Questions</h2>
        </v-layout>
        <v-layout>
            <v-text-field solo label="Name" v-model="questionText"></v-text-field>
            <v-btn @click="createQuestion" text color="success">add new question</v-btn>

        </v-layout>
        <v-layout>
            <v-data-table v-if="questions.length > 0" :hide-default-footer="true" :items-per-page="20" :headers="[
                /* { text: 'NUMBER', value: 'id_playlist' }, */
                { text: 'ID', value: 'id' },
                { text: 'TEXT', value: 'text' },
                { text: 'EDIT', value: 'actions', sortable: false },
            ]" :items="questions">
                <template v-slot:item.actions="{ item }">
                    <v-btn text @click="deleteQuestion(item.id)" color="error">delete</v-btn>
                </template>
            </v-data-table>
        </v-layout>
        <v-layout>
            <h2>Answers</h2>
        </v-layout>
        <v-layout>
            <v-text-field solo label="Name" v-model="answerText"></v-text-field>
            <v-select label="Question" v-model="questionId" :items="questions" item-text="text" item-value="id" solo></v-select>
            <v-btn @click="createAnswer" text color="success">add new answer</v-btn>

        </v-layout>
        <v-layout>
            <v-data-table v-if="answers.length > 0" :hide-default-footer="true" :items-per-page="20" :headers="[
                /* { text: 'NUMBER', value: 'id_playlist' }, */
                { text: 'ID', value: 'id' },
                { text: 'TEXT', value: 'text' },
                { text: 'Question', value: 'question' },
                { text: 'EDIT', value: 'actions', sortable: false },
            ]" :items="answers">
            <template v-slot:item.question="{ item }">
                    {{getName(item.id_question)}}
                </template>
                <template v-slot:item.actions="{ item }">
                    <v-btn text @click="deleteanswer(item.id)" color="error">delete</v-btn>
                </template>
            </v-data-table>
        </v-layout>
    </div>
</template>
<script>
export default {
    data() {
        return {
            questions: null,
            answers: null,
            questionText: '',
            answerText: '',
            questionId:null

        }
    },
    methods: {
        getName(id)
        {
            return this.questions.find(x=>x.id==id).text;
        },
        createAnswer(){

            let obj = {
                id_question: this.questionId,
                text: this.answerText
            };

            axios.post('admin/dislike/addDislikeAnswers',obj).then(async (res) => {
                await this.getAnswers();
                this.$notify({
                    title: "success",
                    text: "Updated!",
                    type: "success",
                    duration: 5000,
                });
            }).catch(err => {
                this.$notify({
                    title: "error",
                    text: "Error on update",
                    type: "error",
                    duration: 5000,
                });
            });


        },
        deleteanswer(id) {
            let newArray = this.answers.filter(item => item.id !== id);
            this.answers = newArray;
            axios.post('admin/dislike/delDislikeAnswers', { id: id }).then((res) => {
                // this.getQuestions();
                this.$notify({
                    title: "success",
                    text: "Updated!",
                    type: "success",
                    duration: 5000,
                });
            }).catch(err => {
                this.sync();
                this.$notify({
                    title: "error",
                    text: "Error on update",
                    type: "error",
                    duration: 5000,
                });
            });
        },
        deleteQuestion(id) {

            let newArray = this.questions.filter(item => item.id !== id);
            this.questions = newArray;
            axios.post('admin/dislike/delDislikeQuestions', { id: id }).then((res) => {
                // this.getQuestions();
                this.$notify({
                    title: "success",
                    text: "Updated!",
                    type: "success",
                    duration: 5000,
                });
            }).catch(err => {
                this.sync();
                this.$notify({
                    title: "error",
                    text: "Error on update",
                    type: "error",
                    duration: 5000,
                });
            });
        },
        createQuestion() {
            axios.post('admin/dislike/addDislikeQuestions', { text: this.questionText }).then(async (res) => {
                await this.getQuestions();
                this.$notify({
                    title: "success",
                    text: "Updated!",
                    type: "success",
                    duration: 5000,
                });
            }).catch(err => {
                this.$notify({
                    title: "error",
                    text: "Error on update",
                    type: "error",
                    duration: 5000,
                });
            });
        },
        getQuestions() {
            axios.post('admin/dislike/getDislikeQuestions').then((res) => {
                this.questions = res.data;
            });
        },
        getAnswers() {
            axios.post('admin/dislike/getDislikeAnswers').then((res) => {
                this.answers = res.data;
            })
        },
        sync() {
            axios.post('admin/dislike/getDislikeQuestions').then((res) => {
                this.questions = res.data;
            });

            axios.post('admin/dislike/getDislikeAnswers').then((res) => {
                this.answers = res.data;
            })
        },
    },
    created() {
        this.sync();
    }

}
</script>
<style lang="scss" scoped></style>